var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScenario9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Investment"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 6 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 15.798V21.798H3.5V15.798H7.5Z",
    stroke: "#6E6E6E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 7 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11.798V21.798H11V11.798H15Z",
    stroke: "#6E6E6E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 8 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 7.79803V21.798H17.5V7.79803H22.5Z",
    fill: "#14AA3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.5 22.798H2.5V20.798H4.5H22.5V22.798Z",
    fill: "#6E6E6E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenario9);
export default __webpack_public_path__ + "static/media/Scenario9.c0e42a3dedc4ff41dcf107e942c4dd0a.svg";
export { ForwardRef as ReactComponent };